import { mapGetters } from 'vuex'

export const hasAccessMixin = {
  created: function () {
    // console.log('Printing from the Mixin')
  },
  computed: {
    ...mapGetters(['token', 'roles', 'username'])
  },
  methods: {
    hasAccess (allowedRoles) {
      // console.log("allowedRoles", allowedRoles)
      if (!allowedRoles || allowedRoles.length === 0) {
        return true
      }
      return this.roles.filter(function (value) {
        return allowedRoles.indexOf(value) > -1
      }).length > 0
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/hasAccessMixin.js